module.exports = __webpack_public_path__ + "img/img12.333eb35d.png";